<template>
  <div v-if="notifications.length" class="notifications__list">
    <div v-for="notification in notifications" :key="notification.id">
      <div class="notification" @click="markAsRead(notification)" :class="notification.isRead ? '' : 'notification--unread'">
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"><path fill="#F5F6FA" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/><path d="M0 0h24v24H0z" fill="none" /></svg>
        <div class="notification__body">
          <!-- prettier-ignore -->
          <span><b>{{ notification.notifier.name }}</b> {{ notification.message }}</span>
          <span class="notification__time">{{ notificationCreated(notification) }}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="notification">
      <span>No notifications</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  async mounted() {
    await this.fetchNotifications()
  },
  methods: {
    ...mapActions(['fetchNotifications', 'markAsRead']),
    notificationCreated(notification) {
      let timeDiff = moment().diff(moment(notification.createdAt), 'minutes')

      if (timeDiff > 1440) {
        timeDiff = moment().diff(moment(notification.createdAt), 'days')
        return `${timeDiff} days ago`
      }

      if (timeDiff > 60) {
        timeDiff = moment().diff(moment(notification.createdAt), 'hours')
        return `${timeDiff} hours ago`
      }

      return `${timeDiff} min ago`
    },
  },
  computed: {
    ...mapGetters(['notifications']),
  },
}
</script>

<style lang="scss" scoped>
.notifications__list {
  flex-direction: column;
  font-size: 0.8em;
  text-align: center;
  cursor: pointer;
  svg {
    margin-right: 0.2rem;
  }
  hr {
    color: #a3a6b4;
    border-style: ridge;
  }
}

.notification {
  display: flex;
  padding: 1em;
  align-items: center;
  background-color: #fafafc;
  border-left: 4px solid #fafafc;
  box-shadow: 0 1px 0 0 #f5f6fa;
  width: 100%;
  opacity: 0.6;
  box-sizing: border-box;
  &:hover {
    background-color: #fafafc;
    opacity: 1;
  }
}

.notification--unread {
  background-color: white;
  border-left: 4px solid var(--color-state);
  opacity: 1;
}

.notification__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // resets
  span {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }
  margin-left: 0.5rem;
}
.notification__time {
  font-size: 0.8em;
  font-weight: 200;
}
</style>
